import * as THREE from 'three';
import { Sky } from "three/examples/jsm/objects/Sky.js";

export default class SkyController {

    private readonly scene: THREE.Scene;
    private readonly sky: Sky;
    private readonly light: THREE.DirectionalLight;
    private readonly lightPivot: THREE.Object3D;
    private readonly ambientLight: THREE.AmbientLight;
    private readonly lightHelper: THREE.CameraHelper;

    constructor(scene: THREE.Scene) {

        this.scene = scene;

        this.sky = new Sky();
        this.sky.scale.setScalar(450000);


        this.light = new THREE.DirectionalLight(0xFFFFFF, 3);
        this.light.position.set(0, 0, 10);
        this.light.castShadow = true;
        this.light.shadow.mapSize.width = 2048;
        this.light.shadow.mapSize.height = 2048;
        this.light.shadow.camera.far = 10000;
        this.light.shadow.camera.near = -10000;
        this.light.shadow.camera.left = -5000;
        this.light.shadow.camera.right = 5000;
        this.light.shadow.camera.top = 5000;
        this.light.shadow.camera.bottom = -5000;
        this.light.shadow.bias = -0.001;

        this.lightPivot = new THREE.Object3D();
        this.light.target = this.lightPivot;
        this.lightPivot.add(this.light);
        this.lightPivot.rotateZ(Math.PI / 6);

        this.ambientLight = new THREE.AmbientLight(0x505070);

        // Create a helper for the shadow camera (optional)
        this.lightHelper = new THREE.CameraHelper(this.light.shadow.camera);

        this.scene.add(this.sky);
        this.scene.add(this.lightPivot);
        this.scene.add(this.ambientLight);
        this.scene.add(this.lightHelper);
    }

    public remove(): void {
        this.scene.remove(this.sky);
        this.scene.remove(this.lightPivot);
        this.scene.remove(this.ambientLight);
        this.scene.remove(this.lightHelper);
    }

    public update(time: number): void {
        const y = time * (Math.PI * 2);
        const z = Math.PI / 6;

        this.lightPivot.setRotationFromEuler(new THREE.Euler(0, y, z, "ZYX"));
        const sunPosition = this.light.getWorldPosition(this.lightPivot.position).normalize();
        this.sky.material.uniforms.sunPosition.value = sunPosition;
    }
}